import { useSelector, useDispatch } from 'react-redux';
import scoreMsgSlice from './scoreMsgSlice';

function useScoreMsg() {
    const { scoreMsg } = useSelector((state) => {
        return state.scoreMsg;
    });
    const dispatch = useDispatch();
  
    function setScoreMsg(scoreMsg) {
      dispatch(scoreMsgSlice.actions.setScoreMsg(scoreMsg));
    }
  
    return { scoreMsg, setScoreMsg };
}

export default useScoreMsg;